export function convertOjectToReadableJson(obj: any,): string {
        // Базовые случаи
    if (obj === null || obj === undefined) {
        return JSON.stringify(obj);
    }
    
    if (typeof obj !== 'object') {
        return JSON.stringify(obj);
    }

    // Обработка массивов
    if (Array.isArray(obj)) {
        const arrayResult = obj.map(item => {
            return convertOjectToReadableJson(item);
        });
        return `[${arrayResult.join(',')}]`;
    }

    // Обработка объектов
    const entries = Object.entries(obj);
    const objectResult = entries.map(([key, value]) => {
        return `"${key}":${convertOjectToReadableJson(value)}`;
    });
    
    return `{${objectResult.join(',')}}`;
}